module.exports = __webpack_public_path__ + "img/sparklesViolet.221f8165.svg";